import subDays from 'date-fns/subDays';
import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import { EDocumentTemplate } from '@/components/modules/account-orders-document-page';
import { TProductItemConfig } from '@/components/modules/orders-page/orders/ui/product-item';
import { getDocument } from '@/components/modules/orders-page/utils/get-document';
import { TOrder } from '@/types/orders';

import { IMAGE_ALT_CUT_LENGTH, DEFAULT_IMAGE_SRC } from '@/shared/constants/settings';
import { useTranslate } from '@/shared/hooks/use-translate';
import { ShowContentByBreakPoint } from '@/shared/ui/show-by-breakpoint';
import { cutString } from '@/shared/utils/string';

import { Badges } from '../badges';

import * as Styled from './styled';

type TProps = {
    photo?: { id: number; image: string; isMain: boolean } | null;
    returned: string | Date;
    order: TOrder;
    pathToProduct: string;
    config: TProductItemConfig;
};

export const Header: FC<TProps> = ({ photo, returned, order, pathToProduct, config }) => {
    const document = getDocument(order);
    const { t } = useTranslate();

    return (
        <Styled.HeaderWrapper className="header">
            <ShowContentByBreakPoint showIf="md">
                <div className="imgBlockMax">
                    <Image
                        src={photo?.image ?? DEFAULT_IMAGE_SRC}
                        alt={cutString(order.rentProduct.name, IMAGE_ALT_CUT_LENGTH)}
                        fill
                    />
                </div>
            </ShowContentByBreakPoint>
            <Styled.HeaderInfoWrapper>
                <div className="title">
                    <Link href={pathToProduct}>{order.rentProduct.name}</Link>
                </div>
                {document && (
                    <div className="contract">
                        <Link
                            href={`/account/orders/document/${EDocumentTemplate.CONTRACT}/${document.id}/${document.state}`}
                            target="_blank"
                        >
                            <span>
                                {t('Договор по аренде №')}
                                {order.number}
                            </span>
                        </Link>
                    </div>
                )}
            </Styled.HeaderInfoWrapper>
            <Badges
                nearestPayDate={order.terms.nearest_pay_date}
                config={config}
                statusName={order.status.name}
                time={order.status.time}
                daysLeft={dayjs(returned).diff(subDays(Date.now(), 1), 'day')}
            />
        </Styled.HeaderWrapper>
    );
};
